import {
  AttributeEditor, Box, FormField, Input, SpaceBetween,
} from '@cloudscape-design/components';
import { Errors, FmWizardState } from './types';

interface Props {
  state: FmWizardState;
  errors: Errors;
  patch: (p: Partial<FmWizardState>) => void;
}

export default function ComputeRolesStep({ state, errors, patch }: Props) {
  const items = state.computeRoles.map((arn, i) => ({ arn, index: i }));

  return (
    <SpaceBetween size="m">
      <Box color="text-body-secondary">
        IAM role ARNs for compute resources that may assume the bundle's inference profiles. At least one is required.
      </Box>
      <AttributeEditor
        items={items}
        addButtonText="Add role ARN"
        removeButtonText="Remove"
        onAddButtonClick={() => patch({ computeRoles: [...state.computeRoles, ''] })}
        onRemoveButtonClick={({ detail }) =>
          patch({ computeRoles: state.computeRoles.filter((_, i) => i !== detail.itemIndex) })}
        definition={[
          {
            label: 'Compute role ARN',
            control: (item) => (
              <FormField
                description="Full IAM role ARN (arn:aws:iam::<account>:role/<name>)."
                errorText={errors[`computeRoles.${item.index}`]}
              >
                <Input
                  value={item.arn}
                  placeholder="arn:aws:iam::123456789012:role/my-role"
                  onChange={({ detail }) =>
                    patch({
                      computeRoles: state.computeRoles.map((r, i) => (i === item.index ? detail.value : r)),
                    })}
                />
              </FormField>
            ),
          },
        ]}
        empty="No compute roles. Add at least one."
      />
    </SpaceBetween>
  );
}
